import { useInterval } from "hooks/useInterval";
import { useCallback, useState } from "react";

export const useTimer = (props: { pauseSecondsRemaining?: number }) => {
    const { pauseSecondsRemaining } = props;

    const [seconds, setSeconds] = useState<number>();
    const [timerEnd, setTimerEnd] = useState<number>();

    const [isPaused, setIsPaused] = useState(false);

    // tick seconds
    const updateSeconds = useCallback(() => {
        if (isPaused) {
            setSeconds(undefined);
        } else if (timerEnd) {
            const now = new Date();
            const endDate = new Date(timerEnd);

            const newTime = Math.max(0, Math.floor((endDate.getTime() - now.getTime()) / 1000));

            setSeconds(newTime);
        } else {
            setSeconds(undefined);
        }
    }, [isPaused, timerEnd]);

    // set timer to update seconds every second
    useInterval(() => {
        if (!pauseSecondsRemaining) {
            updateSeconds();
        }
    }, 1000);

    return {
        seconds,
        setTimerEnd,
        setIsPaused,
    };
};
